import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import { LocaleKey, AppLocales } from '../../../utils/language.util';
import FormInputDateProps from './FormInputDateProps';

export const FormInputDate = ({ name, control }: FormInputDateProps) => {
  const {
    i18n: { language },
  } = useTranslation();

  const maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + 2);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange } }) => (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={AppLocales[language as LocaleKey]}>
          <DatePicker
            value={value}
            onChange={(event) => {
              onChange(event);
            }}
            maxDate={maxDate}
            disablePast
          />
        </LocalizationProvider>
      )}
    />
  );
};
